import { render, staticRenderFns } from "./MenuSide.vue?vue&type=template&id=62677dbf&"
import script from "./MenuSide.vue?vue&type=script&lang=js&"
export * from "./MenuSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports